export const categoryGroups = [
  'Type of Libraries'
]

// one more categories?

export const styles = [{
    //style for defaults
    group: 'Type of Libraries',
    categoryName: 'Academic Library',
    fillColor: '#1aa139',
    strokeColor: '#000',
    icon: 'grocery.png'
  },
  {
    group: 'Type of Libraries',
    categoryName: 'Public Library',
    fillColor: '#69b657',
    strokeColor: '#000',
    icon: 'bread.png'
  },
  {
    group: 'Type of Libraries',
    categoryName: 'Other',
    fillColor: '#002485',
    strokeColor: '#000',
    icon: 'blank.png'
  },
  {
    group: 'Type of Libraries',
    categoryName: 'Consortium',
    fillColor: '#456987',
    strokeColor: '#000',
    icon: 'blank.png'
  },
  {
    group: 'Type of Libraries',
    categoryName: 'Member Organization',
    fillColor: '#deadef',
    strokeColor: '#000',
    icon: 'blank.png'
  },
]
